import { FC, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-daisyui';
import LoadingButton from '@/components/functional/LoadingButton/LoadingButton';
import useDeletePaperAttempt from '@/api/useDeletePaperAttempt';

interface ExitPaperAttemptButtonProps {
  attemptId: string;
}

const ExitPaperAttemptButton: FC<ExitPaperAttemptButtonProps> = ({ attemptId }) => {
  const navigate = useNavigate();
  const deletePaperAttempt = useDeletePaperAttempt();
  const [showExitModal, setShowExitModal] = useState(false);

  const handleExit = useCallback(async () => {
    try {
      await deletePaperAttempt.mutateAsync({ attemptId });
      setShowExitModal(false);
      navigate('/');
    } catch (error) {
      console.error('Failed to delete paper attempt:', error);
    }
  }, [attemptId, deletePaperAttempt, navigate]);

  return (
    <>
      <button
        onClick={() => setShowExitModal(true)}
        className="bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-xl font-medium"
      >
        Exit
      </button>

      {/* Exit Confirmation Modal */}
      <Modal open={showExitModal} onClose={() => setShowExitModal(false)} className="max-w-md">
        <Modal.Header className="font-bold text-xl">Exit Past Paper?</Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to exit? All your progress will be lost and this attempt will be deleted. You will not
            be able to resume later.
          </p>
        </Modal.Body>
        <Modal.Actions className="flex gap-3">
          <button
            onClick={() => setShowExitModal(false)}
            className="flex-1 bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-xl font-medium hover:bg-gray-50"
            disabled={deletePaperAttempt.isPending}
          >
            Cancel
          </button>
          <LoadingButton
            loading={deletePaperAttempt.isPending}
            onClick={handleExit}
            className="flex-1 bg-red-500 hover:bg-red-600 border-none text-white px-6 py-3 rounded-xl font-medium"
          >
            Exit
          </LoadingButton>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ExitPaperAttemptButton;
